export const MAX_CORES_SALVAS = 12;

export type TipoDeCor = 'solid' | 'gradient';
export type ListaDeCores = 'salvas' | 'ocultas';

const chave = (lista: ListaDeCores, tipo: TipoDeCor) =>
  `empreender-ui:cores-${lista}:${tipo}`;

export const lerCores = (lista: ListaDeCores, tipo: TipoDeCor): string[] => {
  try {
    const bruto = localStorage.getItem(chave(lista, tipo));
    if (!bruto) return [];

    const cores = JSON.parse(bruto);
    if (!Array.isArray(cores)) return [];

    return cores.filter((cor) => typeof cor === 'string').slice(0, MAX_CORES_SALVAS);
  } catch {
    return [];
  }
};

export const gravarCores = (
  lista: ListaDeCores,
  tipo: TipoDeCor,
  cores: string[]
) => {
  try {
    localStorage.setItem(
      chave(lista, tipo),
      JSON.stringify(cores.slice(0, MAX_CORES_SALVAS))
    );
  } catch {
    /* empty */
  }
};
